"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitContextLossOnEntityGlBuffers = void 0;
/**
 * @internal
 */
function emitContextLossOnEntityGlBuffers(entityBuffers) {
    const layouts = entityBuffers.getAllLayouts();
    for (let i = 0, iEnd = layouts.length; i < iEnd; ++i) {
        const buffers = layouts[i].getBuffers();
        for (let j = 0, jEnd = buffers.length; j < jEnd; ++j) {
            buffers[j].onContextLost();
        }
    }
}
exports.emitContextLossOnEntityGlBuffers = emitContextLossOnEntityGlBuffers;
//# sourceMappingURL=emit-context-loss-on-entity-gl-buffers.js.map